// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__tRuHR"};